var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUartDataBit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.06 122.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6fccdd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-3 {\r\n        letter-spacing: 0em;\r\n      }\r\n\r\n      .cls-4 {\r\n        font-size: 20.36px;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        fill: #943233;\r\n        font-family: Montserrat-Black, Montserrat;\r\n        font-weight: 800;\r\n      }\r\n\r\n      .cls-5 {\r\n        font-size: 26.24px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #97d3bb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(8.37 27.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0 1 00 11 0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 31.49,
    xmlSpace: "preserve"
  }, "0 1         1 0"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 62.99,
    xmlSpace: "preserve"
  }, "0 1         1 0")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.03,0H7.03C3.14,0,0,3.15,0,7.04v83.63c0,3.89,3.14,7.04,7.03,7.04h144c3.88,0,7.03-3.15,7.03-7.04V7.04c0-3.89-3.15-7.04-7.03-7.04ZM153.48,87.84c0,3.88-3.15,7.03-7.04,7.03H11.62c-3.89,0-7.04-3.15-7.04-7.03V9.87c0-3.88,3.15-7.03,7.04-7.03h134.82c3.89,0,7.04,3.15,7.04,7.03v77.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.93,
    y: 97.71,
    width: 26.21,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.82,
    y: 118.4,
    width: 60.41,
    height: 4.14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.25,30.72h-50.1c-3.16,0-5.73,2.57-5.73,5.73v50.1c0,3.16,2.56,5.72,5.72,5.72h44.73c1.78,0,3.46-.42,4.95-1.17,2.15-1.07,3.9-2.82,4.98-4.97.75-1.49,1.17-3.17,1.17-4.95v-44.73c0-3.16-2.57-5.73-5.73-5.73ZM89.46,72.76c-.86.86-1.78,1.59-2.76,2.21-8.68,5.49-21.54,1.77-24.56-11.19-.35-1.51-.35-3.09,0-4.6,3.41-14.37,18.9-17.33,27.32-8.92,5.36,5.36,6.1,13.59,2.21,19.74-.62.98-1.36,1.91-2.21,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.85,91.16l-16.12-16.12c6.59-8.98,5.82-21.66-2.29-29.78-8.96-8.96-23.49-8.96-32.46,0-8.96,8.96-8.96,23.49,0,32.46,8.12,8.12,20.8,8.89,29.77,2.29l17.33,17.33c4.66.28,5.95-4,3.76-6.18ZM91.67,69.99c-.62.98-1.36,1.91-2.21,2.76-.86.86-1.78,1.59-2.76,2.21-8.68,5.49-21.54,1.77-24.56-11.19-.35-1.51-.35-3.09,0-4.6,3.41-14.37,18.9-17.33,27.32-8.92,5.36,5.36,6.1,13.59,2.21,19.74Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(66.44 68.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.88,
    y: 0
  }, "1"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUartDataBit);
export default __webpack_public_path__ + "static/media/uart-data-bit.27c2c6d49193e3c52a5152ee6037d9eb.svg";
export { ForwardRef as ReactComponent };